import { CampaignRouletteStatus } from '@/@types/campaign-roulette';

export const STATUS_MAP: Record<string, CampaignRouletteStatus> = {
  'ACTIVE': CampaignRouletteStatus.ATIVA,
  'INACTIVE': CampaignRouletteStatus.INATIVA,
  'SCHEDULED': CampaignRouletteStatus.AGENDADA,
  'ENDED': CampaignRouletteStatus.ENCERRADA,
  'FINISHED': CampaignRouletteStatus.ENCERRADA,
} as const;

/**
 * Maps backend status to frontend status considering soft delete
 * @param backendStatus - Status returned by API
 * @param deletedAt - Deletion date (if exists)
 * @returns Formatted status for frontend
 */
export function mapStatusToFrontend(
  backendStatus: string, 
  deletedAt: string | null
): CampaignRouletteStatus {
  if (deletedAt) {
    return CampaignRouletteStatus.INATIVA;
  }

  const normalizedStatus = backendStatus?.toUpperCase();
  const mappedStatus = STATUS_MAP[normalizedStatus];
  
  return mappedStatus ?? CampaignRouletteStatus.ENCERRADA;
}
